import { Action, Reducer } from "redux";
import { SignalRActionTypes, SignalRState, SignalRTypes } from "./signalRTypes";
import { isNullUndefined } from "@/main/services/utils";

export const INITIAL_STATE: SignalRState = {
	isConnected: false,
	content: {},
	sendUpdatesSignalRTypeCurrent: 0,
};

const signalRReducer: Reducer<SignalRState> = (state: SignalRState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as SignalRActionTypes;
	switch (actionTypes.type) {
		case SignalRTypes.SIGNALR_USER_CONNECTED:
			return {
				...state,
				isConnected: true,
			};
		case SignalRTypes.SIGNALR_DISCONNECT:
			return {
				...state,
				isConnected: false,
			};
		case SignalRTypes.SIGNALR_CLEAR_RECEIVE_UPDATES_BYKEY:
			if (!isNullUndefined(state.content) && Object.keys(state.content).length > 0) {
				const keyToDelete = actionTypes.payload.key;
				const newStateContent = Object.keys(state.content).reduce((acc, key) => {
					const keyConverted = Number(key);
					if (keyConverted !== keyToDelete) {
						acc[keyConverted] = state.content[keyConverted];
					}
					return acc;
				}, {});

				return {
					...state,
					content: isNullUndefined(newStateContent) ? {} : newStateContent,
					sendUpdatesSignalRTypeCurrent:
						keyToDelete === state.sendUpdatesSignalRTypeCurrent ? 0 : state.sendUpdatesSignalRTypeCurrent,
				};
			}
			return state;
		case SignalRTypes.SIGNALR_CLEAR_ALL_RECEIVE_UPDATES:
			return {
				...state,
				content: {},
				sendUpdatesSignalRTypeCurrent: 0,
			};
		case SignalRTypes.SIGNALR_RECEIVE_UPDATES: {
			const sendUpdatesSignalRTypeCurrent = actionTypes.payload.content.sendUpdatesSignalRType;

			// Save ReceiveUpdates
			let newStateContent = {};
			if (sendUpdatesSignalRTypeCurrent in state.content) {
				const currentDataByKey = state.content[sendUpdatesSignalRTypeCurrent];
				const newDataByKey = [...currentDataByKey, actionTypes.payload.content];
				newStateContent = {
					...state.content,
					[sendUpdatesSignalRTypeCurrent]: newDataByKey,
				};
			} else {
				newStateContent = {
					...state.content,
					[sendUpdatesSignalRTypeCurrent]: [actionTypes.payload.content],
				};
			}

			return {
				...state,
				sendUpdatesSignalRTypeCurrent,
				content: newStateContent,
			};
		}
		default:
			return state;
	}
};

export default signalRReducer;
